module.exports = __webpack_public_path__ + "img/anc-concert-2019.e15292bb.jpg";